export default __webpack_public_path__ + "static/media/tonchin.b50f527e.jpeg";